// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmojiCategory__button-d957b6 {
  margin: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/EmojisStickersButton/EmojiStickersPanel/EmojiPanel/EmojiCategoryList/EmojiCategory/EmojiCategory.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF","sourcesContent":[".button {\n  margin: 0 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `EmojiCategory__button-d957b6`
};
module.exports = ___CSS_LOADER_EXPORT___;
